import React, { useEffect, useState } from 'react';
import { Typography, Container, Button, InputLabel, Grid, Paper, Toolbar, CircularProgress } from '@material-ui/core'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { NotificationActions, PayOffListActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
    },

    infoTitle: {
        "& h1": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 5px auto'
        }
    },
    amount: {
        fontSize: '14px',
    },
    headerTitle: {
        fontWeight: 'bold',
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const payOffListSelector = (state) => state.PayOffList;
const IdentitySelector = (state) => state.Identity;

// 精算未了（過去分）画面
const PayOffUnprocessedElapse = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const payOffListActions = bindActionCreators(PayOffListActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { listElapse, nowWainting } = useSelector(payOffListSelector);
    const { token } = useSelector(IdentitySelector);

    const { classes } = props;

    const listDefinition = {
        columns: [
            {
                // 処理日時
                title: <FormattedMessage id="Adjustment.ProcessingDate" />,
                field: 'transaction_dt',
                type: 'datetime',
                filtering: false
            },
            {
                // 種別
                title: <FormattedMessage id="Adjustment.Type" />,
                field: 'transaction_type_name',
                filtering: true,
            },
            {
                // 金額
                title: <FormattedMessage id="Adjustment.AmountOfMoney" />,
                field: 'payment_amount',
                type: 'currency',
                currencySetting: { currencyCode: 'JPY', minimumFractionDigits: 0, maximumFractionDigits: 0 },
                filtering: false
            },
        ]
    };

    /**
     * 
     * 戻る押下時の処理
     *
     */
    const onBackClick = () => {
        props.onCancel();
    }

    const placeholder = <FormattedMessage id="Table.Action" />;

    if (listElapse == null || listElapse.length == 0) {
        return <div></div>;
    }

    // 確定日
    const fdt = new Date(props.fixedDt);
    var fixDt = fdt.getFullYear() + '年' + ("0" + (fdt.getMonth() + 1)).slice(-2) + '月' + ("0" + fdt.getDate()).slice(-2) + '日';

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Toolbar variant="regular">
                    <div>
                        <Typography component="h1" variant="inherit">{<FormattedMessage id="Adjustment.PayOffUnprocessedElapse" />}</Typography>
                    </div>
                </Toolbar>
                <Grid container className={classes.form} spacing={2}>
                    <Grid item xs={3}>
                        <InputLabel component="legend" className={classes.headerTitle}><FormattedMessage id={"Adjustment.MerchantName"} /></InputLabel>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel component="legend">{props.merchantName}</InputLabel>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel component="legend" className={classes.headerTitle}><FormattedMessage id={"Adjustment.MerchantType"} /></InputLabel>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel component="legend">{props.merchantType}</InputLabel>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel component="legend" className={classes.headerTitle}><FormattedMessage id={"Adjustment.FixedDate"} /></InputLabel>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel component="legend">{fixDt}</InputLabel>
                    </Grid>
                </Grid>
            </Paper>
            <MaterialTable
                title={<Typography component="h2" variant="inherit">{<FormattedMessage id="Adjustment.ResultsTitle" />}</Typography>}
                columns={listDefinition.columns}
                data={listElapse}
                options={{
                    search: false,
                    filtering: true,
                    actionsColumnIndex: -1,
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                    },
                    header: {
                        actions: ''
                    },
                }}
                components={{
                    // 右端のアクションボタン列（なし）
                    Action: actionProps => {
                        return (
                            <div></div>
                        )
                    },
                }}
                editable={{
                    onRowAdd: newData => { },
                    onRowUpdate: (newData, oldData) => { }
                }}
            />
            <div style={{ padding: 10 }}>
                <Grid container item xs={12} spacing={2} justify="center">
                    <Grid item xs={3} sm={6}>
                        <Button fullWidth variant="contained" size="medium"
                            startIcon={<ArrowBackIosIcon />}
                            onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                    </Grid>
                </Grid>
            </div>

            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(PayOffUnprocessedElapse);
